// src/components/ui/AtlasStyledButton.jsx
import React from 'react';
import AkButton from '@atlaskit/button/new';
// Logos
import { ReactComponent as AtlassianLogo } from '../../../assets/atlassian.svg';
import slack from '../../../assets/slack.png';
import confluence from '../../../assets/confluence.png';
import jira from '../../../assets/jira.png';
import ai from '../../../assets/ai.webp';
import { ReactComponent as ZoomLogo } from '../../../assets/zoom.svg';

export default function Button({
  children,
  onClick,
  variant,
  type = 'button',
  showLogo = true,
  appearance = 'primary',
  spacing = 'default',
  style,
  ...rest
}) {
  const ICONS = {
    atlassian: <AtlassianLogo width={18} height={18} />,
    slack: <img src={slack} alt="slack" width={18} height={18} />,
    confluence: <img src={confluence} alt="confluence" width={18} height={18} />,
    jira: <img src={jira} alt="jira" width={18} height={18} />,
    zoom: <ZoomLogo width={18} height={18} />,
    ai: <img src={ai} alt="ai" width={18} height={18} />,
  };

  const hasIcon = ICONS[variant] && showLogo;

  // Branded variants that should use default appearance
  const customVariants = ['atlassian', 'confluence', 'jira', 'slack', 'zoom']; 
  appearance = customVariants.includes(variant) ? 'default' : (variant || 'primary');

  return (
    <AkButton
      appearance={appearance}
      spacing={spacing}
      onClick={onClick}
      type={type}
      style={style}
      {...rest}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {hasIcon && ICONS[variant]}
        {children}
      </span>
    </AkButton>
  );
}
